import { Canvas, useFrame } from "@react-three/fiber";
import { Suspense, useRef } from "react";

function Shape({ kind, color }) {
  const r = useRef(null);
  useFrame((s) => {
    if (!r.current) return;
    const t = s.clock.getElapsedTime();
    r.current.rotation.x = t * 0.3;
    r.current.rotation.y = t * 0.45;
  });
  return (
    <mesh ref={r}>
      {kind === "globe" && <icosahedronGeometry args={[1.1, 1]} />}
      {kind === "cube" && <boxGeometry args={[1.4, 1.4, 1.4]} />}
      {kind === "pyramid" && <coneGeometry args={[1.1, 1.6, 4]} />}
      <meshStandardMaterial
        color={color}
        emissive={color}
        emissiveIntensity={0.4}
        wireframe
      />
    </mesh>
  );
}

export default function ServiceCardScene({ kind = "globe", color = "#ff4500" }) {
  return (
    <Canvas
      dpr={[1, 1.4]}
      camera={{ position: [0, 0, 3.6], fov: 50 }}
      gl={{ antialias: true, alpha: true }}
    >
      <ambientLight intensity={0.5} />
      <pointLight position={[3, 2, 2]} intensity={1.5} color={color} />
      <pointLight position={[-3, -2, 2]} intensity={1} color="#ffffff" />
      <Suspense fallback={null}>
        <Shape kind={kind} color={color} />
      </Suspense>
    </Canvas>
  );
}
